import React from 'react';
import {Box} from '@mui/material';
import {Field, useFormikContext} from 'formik';
import BaseStep from 'high-school-student/account-conversion/components/base-step';
import styles from './satisfaction.module.scss';
import {findIndex} from 'lodash';
import {AchievementCard} from 'shared/registration/components/achievement-cards';
import Icon from 'shared/components/icon';
import {Answer, LikertQuestion as LikertQuestionType} from '../types';

const LikertQuestion = (props: {question: LikertQuestionType}): React.ReactElement => {
  const {values} = useFormikContext<{answers: Answer[]}>();
  const index = findIndex(values.answers, {questionId: props.question._id});

  return (
    <BaseStep stepHeader={props.question.text} subHeader={props.question.subheading}>
      <div className={styles.container}>
        <Field name={`answers[${index}].content`} id={props.question.identifier} type="text">
          {({field: {name, value}, form: {setFieldValue}}): React.ReactElement[] =>
            props.question.options.map((option, i) => {
              const optionValue = option.value || option.text;
              const selected = value === optionValue;

              return (
                <AchievementCard
                  key={option._id}
                  label={option.text}
                  selected={selected}
                  onClick={(): void => setFieldValue(name, optionValue)}
                  identifier={`${props.question.text} - ${option.text}`}
                  testid={`likert-option-${i}`}
                >
                  <Box
                    display="flex"
                    flexDirection="column"
                    height="70px"
                    justifyContent="space-between"
                  >
                    {option.text}
                    <Icon
                      iconType={`check-circle${selected ? '' : '-r'}`}
                      color={selected ? 'blue' : 'lightgrey'}
                    />
                  </Box>
                </AchievementCard>
              );
            })
          }
        </Field>
      </div>
    </BaseStep>
  );
};

export default LikertQuestion;
